var S=Object.freeze({STATUS_SUCCESS:"success",STATUS_FAILED:"failed",STATUS_ONGOING:"ongoing",STATUS_EXISTING:"existing"});export{S as STATUS};
//# sourceMappingURL=file.constants.js.map
